export default (date, metricKey, seoMetric = false) => {
  const metric = metricKey.toLowerCase();
  let inflated = false;
  if (!seoMetric) {
    if (metric.includes("roas")) {
      inflated = true;
    } else if (metric.includes("cpa")) {
      inflated = true;
    } else if (metric.includes("revenue")) {
      inflated = true;
    } else if (metric.includes("conversions")) {
      inflated = true;
    }
  }
  
  const today = moment();
  let lockDate = moment(date);
  if (inflated) {
    lockDate.endOf("month").add(30, "days")
  } else {
    lockDate.endOf("month").add(1, "days")
  }

  return today >= lockDate;
};
